$(function () {
    // PCナビ
    $(".gnav > ul > .has-child > span").click(function(){
        if($(this).attr('class') == 'active') {
            // メニュー非表示
            $(this).removeClass('active').next('ul').slideUp('400ms');
        }else{
            // 表示しているメニューを閉じる
            $('.gnav > ul > .has-child > span').removeClass('active');
            $('.gnav > ul > .has-child > ul').hide();
            // メニュー表示
            $(this).addClass('active').next('ul').slideDown('400ms');
        }
    });

    $('.gnav a').click(function(){
        $('.gnav > ul > .has-child > span').removeClass('active');
        $('.gnav > ul > .has-child > ul').slideUp('400ms');
    });

    // スマホ　メニューボタン
    $(".menu-btn > span").click(function(){
        $(this).toggleClass("active"); //メニューボタンの切り替え
        $('body').toggleClass('drower-open');
        return false;
    });
    $(".gnav li a").click(function(){ //ナビのリンク押したらナビ閉じる
        $('.menu-btn span').removeClass("active");
        $('body').removeClass('drower-open');
        //return false;
    });

    // Language
    $(".f__header #lang-btn").click(function(){
        $('body').toggleClass('lang-open');
        return false;
    });

    // 他の領域クリックで閉じる
    $(document).click(function(event){
        if(!$(event.target).closest('.f__header .lang').length){
            $('body').removeClass('lang-open');
        }
        if(!$(event.target).closest('.gnav').length){
            $('.gnav > ul > .has-child > span').removeClass('active');
            $('.gnav > ul > .has-child > ul').slideUp('400ms');
        }
    });

    // gsearch
    $(".f__header #gsearch-btn").click(function(){
        $('body').addClass('gsearch-open');
        return false;
    });
    $(".f__header #gsearch-close-btn").click(function(){
        $('body').removeClass('gsearch-open');
        return false;
    });
});
